import styles from './SummerMainSection.module.css';
import { MainSection } from '@features/landing/shared/ui/sections/MainSection';
import { ImportantText } from '@features/landing/shared/ui/components/ImportantText';

export function SummerMainSection() {
  return (
    <MainSection
      title={
        <div className={styles.title}>
          Летний блиц и&nbsp;рапид РШШ на&nbsp;рейтинг ФШР по&nbsp;вторникам
          и&nbsp;четвергам
        </div>
      }
      details={
        <div className={styles.detailsContent}>
          Турниры с&nbsp;разделением по&nbsp;рейтинговым
          <br />
          лигам для&nbsp;участников{' '}
          <ImportantText
            className={styles.detailsImportant}
            preset="text-green-1"
          >
            2008 г.р. и младше
          </ImportantText>
        </div>
      }
    />
  );
}
